import React from 'react';
import { PersonCircle, List } from 'react-bootstrap-icons';
import './Navbar.css';

export function Navbar({ onToggleSidebar, isMobile }) {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <button className="sidebar-toggle" onClick={onToggleSidebar}>
            <List size={24} />
          </button>
          {!isMobile && <span className="navbar-brand">Dashboard</span>}
        </div>
        
        <div className="navbar-right">
          <div className="user-menu">
            <div className="dropdown">
              <button
                className="user-dropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <PersonCircle size={20} className="user-icon" />
                <span className="user-name">Admin</span>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li><a className="dropdown-item" href="#">Profile</a></li>
                <li><hr className="dropdown-divider" /></li>
                <li><a className="dropdown-item text-danger" href="#">Logout</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}